<template>
  <div class="requisition-report-comments-toggle">
    <v-menu
      location="bottom right"
      :close-on-content-click="false"
      offset="-6"
      :model-value="showComments"
      @update:model-value="setShowComments($event)"
    >
      <template #activator="{ props, isActive }">
        <v-btn
          class="toggle-button"
          color="textDarkest"
          variant="text"
          :height="40"
          :min-width="40"
          :max-width="40"
          :value="showComments"
          v-bind="props"
        >
          <v-icon icon="$message-outline" :color="isActive ? 'white' : 'iconDarkest'" />
          <RequisitionReportCommentsNotificationBadge :req-uuid="reqUuid" />
        </v-btn>
      </template>

      <RequisitionReportComments
        :req-id="reqId"
        :req-uuid="reqUuid"
        :req-title="reqTitle"
      />
    </v-menu>
  </div>
</template>

<script>
import { useCommenting } from '@/stores/commenting/commenting';
import RequisitionReportComments from '@/components/requisitions/RequisitionReportComments.vue';
import RequisitionReportCommentsNotificationBadge
  from '@/components/requisitions/RequisitionReportCommentsNotificationBadge.vue';

export default {
  name: 'RequisitionReportCommentsToggle',

  components: { RequisitionReportComments, RequisitionReportCommentsNotificationBadge },

  props: {
    reqId: { type: String, default: '' },
    reqUuid: { type: String, default: '' },
    reqTitle: { type: String, default: '' },
  },

  computed: {
    showComments() {
      return useCommenting().showComments;
    },
  },

  mounted() {
    if (this.$route?.query.showComments) {
      this.setShowComments(true);
    }
    return useCommenting().loadCord();
  },

  methods: {
    setShowComments(show) {
      useCommenting().setShowComments(show);
    },
  },
};
</script>

<style scoped lang="less">
.requisition-report-comments-toggle {
  .toggle-button {
    border: solid 1px @stroke-default;
    border-radius: 8px;
    padding: 12px;
    background-color: @white;

    :deep(.v-icon) {
      color: @text-darkest;
    }

    &[aria-expanded="true"], &:hover {
      background-color: @text-brand;

      :deep(.v-icon) {
        color: @white !important;
      }
    }
  }

  .requisition-report-comments-notification-badge {
    position: absolute;
    top: -8px;
    right: -8px;
  }
}
</style>
